import React from 'react';
import { Ellipsis } from 'react-spinners-css';

export const SmallLoading: React.FunctionComponent<{ isLoading: boolean }> = (props) => {
    const { isLoading } = props;
    
    if (isLoading === false) {
        return <React.Fragment></React.Fragment>
    }
    return (
        <React.Fragment>
            <div
                style={{
                    marginTop: '20px',
                    marginLeft: '50%',
                    marginRight: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <Ellipsis color="black" size={30} />
            </div>
        </React.Fragment>
    );
};
